export const NAV = {
  logo: "app-logo",
  navDashboard: "nav-dashboard",
  navGmail: "nav-gmail",
  navDetected: "nav-detected",
  navChildren: "nav-children",
  navTasks: "nav-tasks",
  navCalendar: "nav-calendar",
  navCopilot: "nav-copilot",
  navBriefing: "nav-briefing",
  navSettings: "nav-settings",
  navLanding: "nav-landing",
  userMenu: "nav-user-menu",
  signOut: "nav-sign-out",
};

export const AUTH = {
  googleSignIn: "auth-google-signin",
  loginRedirect: "auth-login-redirect",
};

export const PASTE = {
  openButton: "paste-open",
  fromName: "paste-from-name",
  fromEmail: "paste-from-email",
  subject: "paste-subject",
  body: "paste-body",
  submit: "paste-submit",
  result: "paste-result",
};

export const LANDING = {
  ctaJoinWaitlistHero: "landing-cta-join-waitlist-hero",
  ctaTryDemo: "landing-cta-try-demo",
  waitlistForm: "waitlist-form",
  waitlistName: "waitlist-name",
  waitlistEmail: "waitlist-email",
  waitlistChildren: "waitlist-children",
  waitlistPain: "waitlist-pain",
  waitlistSubmit: "waitlist-submit",
  waitlistSuccess: "waitlist-success",
  pricingMonthly: "pricing-monthly-cta",
  pricingYearly: "pricing-yearly-cta",
  faqItem: "faq-item",
};

export const DASHBOARD = {
  page: "dashboard-page",
  askCopilotBtn: "dashboard-ask-copilot",
  kpiActionRequired: "kpi-action-required",
  kpiThisWeek: "kpi-this-week",
  kpiCalendarSuggestions: "kpi-calendar-suggestions",
  kpiDetected: "kpi-detected-messages",
  taskItem: "dashboard-task-item",
  suggestionConfirm: "dashboard-suggestion-confirm",
};

export const DETECTED = {
  page: "detected-page",
  emailCard: "detected-email-card",
  keep: "detected-keep",
  reject: "detected-reject",
  alwaysInclude: "detected-always",
  neverInclude: "detected-never",
  feedbackCorrect: "detected-feedback-correct",
  feedbackIncorrect: "detected-feedback-incorrect",
  feedbackDialog: "detected-feedback-dialog",
  feedbackSubmit: "detected-feedback-submit",
  feedbackType: "detected-feedback-type",
  feedbackNotes: "detected-feedback-notes",
};

export const ANALYTICS = {
  page: "analytics-page",
  totalCard: "analytics-total",
  accuracyCard: "analytics-accuracy",
  rowMostCorrected: "analytics-row-corrected",
  rowSender: "analytics-row-sender",
};

export const GMAIL = {
  page: "gmail-page",
  emailRow: "gmail-email-row",
  connectBtn: "gmail-connect-btn",
  syncBtn: "gmail-sync-btn",
  disconnectBtn: "gmail-disconnect-btn",
  connectedBanner: "gmail-connected-banner",
};

export const TASKS = {
  page: "tasks-page",
  toggle: "task-toggle",
};

export const CALENDAR_PAGE = {
  page: "calendar-page",
  confirm: "calendar-confirm",
  dismiss: "calendar-dismiss",
};

export const COPILOT = {
  page: "copilot-page",
  input: "copilot-input",
  send: "copilot-send",
  suggested: "copilot-suggested",
  messages: "copilot-messages",
};

export const CHILDREN = {
  page: "children-page",
  emptyState: "children-empty-state",
  emptyAddBtn: "children-empty-add",
  emptyLoadDemoBtn: "children-empty-load-demo",
  addBtn: "children-add",
  addNameInput: "children-add-name",
  addGradeInput: "children-add-grade",
  ruleAdd: "rule-add",
  ruleDelete: "rule-delete",
  card: (id) => `child-card-${id}`,
  editBtn: (id) => `child-edit-${id}`,
  deleteBtn: (id) => `child-delete-${id}`,
  editModal: "child-edit-modal",
  editNameInput: "child-edit-name",
  editGradeInput: "child-edit-grade",
  editSchoolInput: "child-edit-school",
  editNotesInput: "child-edit-notes",
  editSaveBtn: "child-edit-save",
  editCancelBtn: "child-edit-cancel",
  resetDemoBtn: "children-reset-demo",
};

export const BRIEFING = {
  page: "briefing-page",
  headline: "briefing-headline",
  regenerateBtn: "briefing-regenerate",
  emailMeBtn: "briefing-email-me",
  childCard: "briefing-child-card",
  conflictRow: "briefing-conflict-row",
  riskRow: "briefing-risk-row",
  actionRow: "briefing-action-row",
  calendarRow: "briefing-calendar-row",
  winsList: "briefing-wins",
  missedList: "briefing-missed",
  deadlineRow: "briefing-deadline-row",
  historyRow: "briefing-history-row",
  dashboardBanner: "dashboard-briefing-banner",
  dashboardBannerOpen: "dashboard-briefing-open",
};

export const SETTINGS = {
  page: "settings-page",
  notifModeRadio: "settings-notif-mode",
  notifSave: "settings-notif-save",
  emailLogRow: "settings-email-log-row",
};

export const HEALTH = {
  card: "health-score-card",
  score: "health-score-value",
  status: "health-score-status",
  trend: "health-score-trend",
  momentum: "health-momentum",
  breakdownRow: "health-score-breakdown-row",
  historyRow: "health-score-history-row",
};

export const INSIGHTS = {
  taskInsight: "task-insight",
  badge: "insights-badge",
};
